__turbopack_context__.v({
  "countLabel": "transactionTypeTabs-module-scss-module__qL8f-G__countLabel",
  "transactionTypeGroups": "transactionTypeTabs-module-scss-module__qL8f-G__transactionTypeGroups",
});
